import { useMutation } from '@apollo/client';
import { useSnackbar } from 'notistack';
import { useContext, useEffect } from 'react';
import LoginContext from '../../context/loginContext';
import { STORAGE_KEYS } from '../../shared/constants';
import SessionService from '../SessionService';
import { LOGIN_USER } from '../userQueries/userService';
import { useNavigate } from 'react-router-dom';
import { useApolloClient } from '@apollo/client';

export default function useAuth() {
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const client = useApolloClient();
  const { authenticated, setAuthenticated } = useContext(LoginContext);
  const [loginUser, { data, loading }] = useMutation(LOGIN_USER, {
    fetchPolicy: 'no-cache',
    onError: err => {
      enqueueSnackbar('Incorrect Email or Password', {
        variant: 'error',
      });
    },
  });

  useEffect(() => {
    if (data?.login?.access_token) {
      SessionService.setItem(
        STORAGE_KEYS.AUTH_TOKEN,
        data.login.access_token,
        'session'
      );
      SessionService.setItem(
        STORAGE_KEYS.REFRESH_TOKEN,
        data.login.refresh_token,
        'session'
      );
      SessionService.setItem(STORAGE_KEYS.WELCOME_BACK, 'true', 'local');
      setAuthenticated(SessionService.isAuthenticated());
    } else if (data?.login?.userId) {
      navigate('/otpverification', {
        state: {
          phoneNumber: data?.login?.phoneNumber,
          userId: data?.login?.userId,
        },
      });
    }
  }, [data, navigate, setAuthenticated]);

  const login = (userName, password) => {
    const loginPayload = {
      loginRequest: {
        userName: userName,
        password: password,
      },
    };
    loginUser({ variables: loginPayload });
  };

  const logout = () => {
    SessionService.removeItem(STORAGE_KEYS.AUTH_TOKEN, 'session');
    SessionService.removeItem(STORAGE_KEYS.REFRESH_TOKEN, 'session');
    client.clearStore();
    setAuthenticated(SessionService.isAuthenticated());
  };

  return { authenticated, login, logout, loading };
}
